import '../assets/NcColorPicker-PzIRM1j1.css';
import i from "../Components/NcButton.mjs";
import { N as c } from "./NcPopover-T4GMXmKV.mjs";
import { r as d, i as u, a as o } from "./_l10n-FmsZpnE4.mjs";
import { d as p } from "./GenColors-wNwbCHuq.mjs";
import { G as f } from "./GenRandomId-VodkdWbp.mjs";
import { A as m } from "./ArrowLeft-uW5eNVkY.mjs";
import { C as h } from "./Check-qy5XrF1J.mjs";
import { D as v } from "./DotsHorizontal-IbmXTXRA.mjs";
import { Chrome as C } from "vue-color";
import { n as _ } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
d(u);
const l = /^#([a-f0-9]{3}|[a-f0-9]{6})$/i, k = {
  name: "NcColorPicker",
  components: {
    ArrowLeft: m,
    Check: h,
    Chrome: C,
    DotsHorizontal: v,
    NcButton: i,
    NcPopover: c
  },
  props: {
    /**
     * A HEX color that represents the initial value of the picker
     */
    value: {
      type: String,
      required: !0
    },
    /**
     * Set to `true` to enable advanced fields including HEX, RGB, and HSL
     */
    advancedFields: {
      type: Boolean,
      default: !1
    },
    /**
     * Limit selectable colors to only the provided palette
     */
    paletteOnly: {
      type: Boolean,
      default: !1
    },
    /**
     * Provide a custom array of colors to show.
     * Can be either an array of string hexadecimal colors,
     * or an array of object with a `color` property with hexadecimal color string,
     * and a `name` property for accessibility.
     *
     * @type {string[] | {color: string, name: string}[]}
     */
    palette: {
      type: Array,
      default: () => [...p],
      validator: (t) => t.every(
        (e) => typeof e == "string" && l.test(e) || typeof e == "object" && e.color && l.test(e.color)
      )
    },
    /**
     * Selector for the popover container
     */
    container: {
      type: [String, Object, Element, Boolean],
      default: "body"
    }
  },
  emits: [
    "submit",
    "close",
    "update:open",
    "update:value",
    "input"
  ],
  data() {
    return {
      currentColor: this.value,
      advanced: !1,
      ariaBack: o("Back"),
      ariaMore: o("More options")
    };
  },
  computed: {
    normalizedPalette() {
      return this.palette.map((t) => ({
        color: typeof t == "object" ? t.color : t,
        name: typeof t == "object" && t.name ? t.name : o("A color with a HEX value {hex}", { hex: t.color })
      }));
    },
    uid() {
      return f();
    },
    contrastColor() {
      const t = "#000000", e = "#FFFFFF";
      return this.calculateLuma(this.currentColor) > 0.5 ? t : e;
    }
  },
  watch: {
    value(t) {
      this.currentColor = t;
    }
  },
  methods: {
    t: o,
    /**
     * Submit a picked colour and close picker
     */
    handleConfirm() {
      this.$emit("submit", this.currentColor), this.handleClose(), this.advanced = !1;
    },
    handleClose() {
      this.$emit("close"), this.$emit("update:open", !1);
    },
    /**
     * Inner navigations
     */
    handleBack() {
      this.advanced = !1;
    },
    handleMoreSettings() {
      this.advanced = !0;
    },
    /**
     * Pick a colour
     *
     * @param {string} color the picked color
     */
    pickColor(t) {
      typeof t != "string" && (t = this.currentColor.hex), this.currentColor = t, this.$emit("update:value", t), this.$emit("input", t);
    },
    /**
     * Calculate luminance of provided hex color
     *
     * @param {string} color the hex color
     */
    calculateLuma(t) {
      const [e, r, a] = this.hexToRGB(t);
      return (0.2126 * e + 0.7152 * r + 0.0722 * a) / 255;
    },
    /**
     * Convert hex color to RGB
     *
     * @param {string} hex the hex color
     */
    hexToRGB(t) {
      const e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
      return e ? [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)] : null;
    }
  }
};
var y = function() {
  var e = this, r = e._self._c;
  return r("NcPopover", e._g(e._b({ attrs: { "popup-role": "dialog", container: e.container }, on: { "apply-hide": e.handleClose }, scopedSlots: e._u([{ key: "trigger", fn: function(a) {
    return [e._t("default", null, null, a)];
  } }], null, !0) }, "NcPopover", e.$attrs, !1), e.$listeners), [r("div", { staticClass: "color-picker", class: { "color-picker--advanced-fields": e.advanced && e.advancedFields }, attrs: { role: "dialog", "aria-label": e.t("Color picker") } }, [r("Transition", { attrs: { name: "slide", mode: "out-in" } }, [e.advanced ? r("Chrome", { staticClass: "color-picker__advanced", attrs: { "disable-alpha": !0, "disable-fields": !e.advancedFields }, on: { input: e.pickColor }, model: { value: e.currentColor, callback: function(a) {
    e.currentColor = a;
  }, expression: "currentColor" } }) : r("div", { staticClass: "color-picker__simple" }, e._l(e.normalizedPalette, function({ color: a, name: n }, s) {
    return r("label", { key: s, staticClass: "color-picker__simple-color-circle", class: { "color-picker__simple-color-circle--active": a === e.currentColor }, style: { backgroundColor: a } }, [a === e.currentColor ? r("Check", { attrs: { size: 20, "fill-color": e.contrastColor } }) : e._e(), r("input", { staticClass: "hidden-visually", attrs: { type: "radio", "aria-label": n, name: `color-picker-${e.uid}` }, domProps: { checked: a === e.currentColor }, on: { click: function(B) {
      return e.pickColor(a);
    } } })], 1);
  }), 0)], 1), e.paletteOnly ? e._e() : r("div", { staticClass: "color-picker__navigation" }, [e.advanced ? r("NcButton", { attrs: { type: "tertiary", "aria-label": e.ariaBack }, on: { click: e.handleBack }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("ArrowLeft", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 1821202730) }) : e._e(), e.advanced ? e._e() : r("NcButton", { attrs: { type: "tertiary", "aria-label": e.ariaMore }, on: { click: e.handleMoreSettings }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("DotsHorizontal", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 1056868794) }), e.advanced ? r("NcButton", { attrs: { type: "primary" }, on: { click: e.handleConfirm } }, [e._v(" " + e._s(e.t("Choose")) + " ")]) : e._e()], 1)], 1)]);
}, b = [], g = /* @__PURE__ */ _(
  k,
  y,
  b,
  !1,
  null,
  "ced724c4",
  null,
  null
);
const G = g.exports;
export {
  G as N
};
